module.exports = __webpack_public_path__ + "img/image62.c349d43a.png";